import ToDoContainer from "../../components/applications/toDo";

const ToDo = () => {
  return <ToDoContainer />;
};

export default ToDo;
